var msg = new Array();
msg['257']='Impossibile trovare il tuo account';
msg['258']='Utente disabilitato, impossibile effettuare il login';
msg['259']='Non è possibile accedere al tuo account';
msg['260']='Password errata. Riprova o fai clic su Password dimenticata per reimpostarla';
msg['261']='Utente guest, in attesa di conferma';
msg['263']='Inserisci il codice OTP per continuare';
msg['264']='Codice OTP errato. Riprova';
msg['267']='L\'indirizzo è già associato ad un account. Effettua l\'accesso per proseguire con l\'acquisto.';
msg['268']='L\'indirizzo è già associato ad un account. Effettua l\'accesso per proseguire con l\'acquisto.';
msg['ERR_CARRIERMISSING']='Devi selezionare un tipo di spedizione';
msg['ERR_CARRIER_COST_MISSING']='Nessuna tariffa applicabile per nazione, corriere e peso dell\'ordine.';
msg['ERR_CLIENTMANDATORYFIELDS']='I campi contrassegnati sono obbligatori';
msg['ERR_EXTRA_EU']='Oops! Al momento non possiamo spedire nel tuo Paese.\nMa non preoccuparti: puoi comunque acquistare i nostri prodotti!\nInvia la tua selezione a <a href="mailto:shop@lopificio.it"><strong>shop@lopificio.it</strong></a> e saremo felici di aiutarti con il tuo ordine.\n\nA presto,\nAnna';
msg['ERR_FILLEMAILFIELD']='Compila il campo email';
msg['ERR_INVALIDMAIL']='Email non valida';
msg['ERR_LOGININVALID']='Email e/o password non validi';
msg['ERR_LOGINREQUIRED']='Devi effettuare l\'accesso';
msg['ERR_MISSINGFIELDS']='Completa correttamente tutti i campi obbligatori';
msg['ERR_NOSIZESELECTED']='Devi prima selezionare una taglia';
msg['ERR_PAYMENT_METHOD']='Seleziona un metodo di pagamento';
msg['ERR_PEC_OR_SDI']='Devi compilare almeno uno di PEC o SdI';
msg['ERR_PRIVACY']='Devi accettare le condizioni';
msg['ERR_SAME_MAIL']="Inserire la stessa email";
msg['ERR_SAME_PASSWORD']="Inserire la stessa password";
msg['ERR_USEREXISTS']='Utente già esistente.';
msg['ERR_VALUE_TOO_HIGH']="Inserire un valore minore o uguale di {0}.";
msg['ERR_WRONG_CODE']='Codice di recupero errato';
msg['LABEL_ALREADYREGISTEREDUSERES']='Utenti già registrati';
msg['LABEL_ARTICLES']='articoli';
msg['LABEL_INVITES_ALREADY_SENT']='Utenti già invitati';
msg['LABEL_NOTAPPLICABLE']='Non applicabili';
msg['LABEL_NOTSENTINVITES']='Inviti non inviati';
msg['LABEL_SELECTALL']='Seleziona tutti';
msg['LABEL_SENTINVITES']='Inviti inviati';
msg['LABEL_SUBMIT']='Invia';
msg['LABEL_WARNING']='Attenzione';
msg['Login to your account']="L'utente esiste già";
msg['MSG_ADDEDTOCART']='Prodotti aggiunti al carrello';
msg['MSG_ADDED_TO_WISHLIST']='Prodotto aggiunto alla lista dei desideri';
msg['MSG_APPLIEDVATCHANGED']='Dopo questo aggiornamento dei dati di fatturazione, l\'IVA applicata al tuo ordine è cambiata.';
msg['MSG_COUPON_ERROR']='Codice coupon inserito non valido o inserito precedentemente.';
msg['MSG_COUPON_VALID']='Codice coupon inserito validato con successo.';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Sarà abilitata la sola prenotazione dell\'ordine e le spese di spedizione verranno comunicate via email';
msg['MSG_EXTRAUELIMIT']='L\'ammontare minimo del tuo ordine non può essere inferiore a 2000.00 &euro;';
msg['MSG_GENERIC_ERROR']='Spiacente, si è verificato un errore.';
msg['MSG_GIFTCARD_ERROR']='Codice giftcard inserito non valido o inserito precedentemente.';
msg['MSG_GIFTCARD_VALID']='Codice giftcard inserito validato con successo.';
msg['MSG_INSUFFICIENT_STOCK']='Al momento la disponibilità del prodotto non è sufficiente';
msg['MSG_MAILSENT']='E-Mail inviate';
msg['MSG_MESSAGE_PRODUCTSHARE']='Messaggio';
msg['MSG_MESSAGE_SENT']='Messaggio inviato!';
msg['MSG_MIXED_CART']='I prodotti nel carrello non possono essere acquistati insieme al prodotto selezionato perchè si trovano in magazzini diversi.';
msg['MSG_MIXED_INTANGIBLE']='I prodotti nel carrello non possono essere acquistati insieme al prodotto selezionato.';
msg['MSG_PASSWORD_NOT_COMPLEX']="Inserire una password che contenga almeno 8 caratteri, una lettera maiuscola, una minuscola e un numero"
msg['MSG_PASSWORD_UPDATED']='Password aggiornata correttamente';
msg['MSG_PROFILECONSENT_SAVED'] = 'Le tue preferenze di contatto sono state aggiornate';
msg['MSG_RECOVEREMAILSENT']='Controlla la tua email e clicca sul link per confermare la modifica.';
msg['MSG_RECOVEREMAILSENT_ERROR']='Attenzione: Non sei registrato con questo indirizzo e-mail o stai già reimpostando una nuova password.';
msg['MSG_RECOVERY_MAIL_SENT']='Abbiamo appena inviato un codice alla tua email. Verifica nella tua posta se hai ricevuto il messaggio che ti è stato inviato e immetti qui il codice';
msg['MSG_REMOVED_FROM_WISHLIST']='Prodotto rimosso dalla lista dei desideri';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Richiesta di reso creata con successo';
msg['MSG_RULE_REJECT']=':rule';
msg['MSG_SAMPLE_NOT_FOUND']='Non è stato trovato nessun campione per il prodotto scelto';
msg['MSG_SAVE_FOR_LATER']='Prodotto aggiunto alla wishlist.<br><a class="gold" href="{0}">Visualizza la tua wishlist</a>';
msg['MSG_SAVE_SUCCESS'] = 'Salvataggio avvenuto con successo';
msg['MSG_SELECT_PROVINCE']='Seleziona una provincia';
msg['MSG_SENDER_PRODUCTSHARE']='Il tuo nome';
msg['MSG_SUBJECT_PRODUCTSHARE']=' ha condiviso qualcosa con te';
msg['MSG_SUBSCRIBED'] = 'Iscritto con successo';
msg['MSG_WAIT']='Attendere...';
msg['MSG_WARN_CHANGE_COUNTRY']='Cambiare paese di spedizione potrebbe comportare a un cambiamento delle spese di spedizione';
msg['login.user.passwordnotcomplexenought']='La nuova password deve avere almeno 8 caratteri e contenere una lettera maiuscola e una lettera minuscola';
msg['login.user.unexisting']='Utente non trovato';
msg['msg.form.invalidtype'] = 'Si è verificato un errore. Contatta l\'amministrazione riportando quanto segue: "Tipo di contatto non valido o assente."';
msg['msg.form.invalidemail'] = 'Email non valida o mancante';
msg['msg.form.invalidrecipients'] = 'Si è verificato un errore. Contatta l\'amministrazione riportando quanto segue: "Destinatari del contatto non validi o assenti."';

/* Keys synced from olip/src/olip/ts/i18n/it.ts */
msg['invalid.captcha']='Non è stato possibile inviare la richiesta a causa di un errore nella verifica di sicurezza.';
msg['login.user.disabled']="Questo account non è più attivo. Contatta l'assistenza per ricevere aiuto.";
msg['login.user.notsubscribed']='Il tua abbonamento non è attivo. Iscriviti per continuare.';
msg['login.user.pending']="Il tuo account è in fase di revisione. Attendi l'approvazione prima di accedere.";
msg['login.user.requireotp']='OTP richiesto';
msg['login.user.waitinglist']="Sei nella lista d'attesa. Ti avviseremo non appena si libererà un posto.";
msg['login.user.wrongotp']='Il codice di verifica inserito non è corretto. Riprova.';
msg['login.user.wrongpassword']='La password inserita non è corretta. Riprova.';
msg['msg.order.expiredcart']='Il tuo carrello è scaduto, è necessario crearne uno nuovo.';
msg['COPY_COPIED']='Copiato!';
msg['COPY_ERROR']='Non è stato possibile copiare!';
msg['COPY_SELECTED']='Selezionato!';
msg['COUPON_ALREADY_BURNED']='Questo codice promozionale è già stato utilizzato e non può essere applicato nuovamente.';
msg['ERR_DATE_FROM']='La data di inizio non può essere prima di :from.';
msg['ERR_DATE_FROM_TO']='La data di inizio non può essere prima di :from o successiva a :to.';
msg['ERR_DATE_TO']='La data di inizio non può essere successiva a :to.';
msg['ERR_LIGHTBOX_LOADING']='Si è verificato un errore durante il caricamento dei dati.';
msg['ERR_MAX_CHECKED']='Seleziona al massimo :max';
msg['ERR_MIN_CHECKED']='Seleziona almeno :min';
msg['ERR_ORDER_MIN']='Seleziona almeno :min quantità';
msg['ERR_PHONE_FORMAT_GENERIC']='Formato numero di telefono non valido.';
msg['ERR_PHONE_FORMAT_INVALID_COUNTRY']='Il numero di telefono non è valido per il paese selezionato.';
msg['ERR_PHONE_FORMAT_NOT_A_NUMBER']='Il numero di telefono deve contenere solo cifre.';
msg['ERR_PHONE_FORMAT_TOO_LONG']='Il numero di telefono è troppo lungo.';
msg['ERR_PHONE_FORMAT_TOO_SHORT']='Il numero di telefono è troppo corto.';
msg['ERR_SELECT_PAYMENT_METHOD']='Seleziona un metodo di pagamento';
msg['ERR_SELECT_SHIPPING_ADDRESS']='Seleziona un indirizzo di spedizione';
msg['ERR_VAT']='Partita IVA non valida.';
msg['ERR_VAT_PREFIX']='La partita IVA deve iniziare con un prefisso nazionale, ad esempio IT12345678900.';
msg['ERR_ZIP_FORMAT']='Formato CAP non valido.';
msg['FAILURE']='Codice promozionale errato o scaduto';
msg['INVALID_COUPON']='Codice promozionale errato o scaduto';
msg['LABEL_CANCEL']='Annulla';
msg['LABEL_CLOSE_LIGHTBOX']='Chiudi dettaglio immagine';
msg['LABEL_CONFIRM']='Conferma';
msg['LABEL_GO_TO_SLIDE']='Vai alla diapositiva :index';
msg['LABEL_MARQUEE_PAUSE_BUTTON']='Metti scorrimento testo in pausa';
msg['LABEL_MARQUEE_RESUME_BUTTON']='Riprendi scorrimento testo';
msg['LABEL_NEXT_IMAGE']='Prossima immagine';
msg['LABEL_NEXT_SLIDE']='Prossima diapositiva';
msg['LABEL_OPEN_LIGHTBOX']='Apri dettaglio immagine';
msg['LABEL_PAGINATION']='Scegli diapositiva';
msg['LABEL_PAUSE_SLIDESHOW']='Metti in pausa slideshow';
msg['LABEL_PREVIOUS_SLIDE']='Diapositiva precedente';
msg['LABEL_PREV_IMAGE']='Immagine precedente';
msg['LABEL_QUANTITY_INPUT_CONTAINER']='Input delle quantità';
msg['LABEL_QUANTITY_INPUT_DECREASE']='Riduci quantità';
msg['LABEL_QUANTITY_INPUT_INCREASE']='Aumenta quantità';
msg['LABEL_RESUME_SLIDESHOW']='Riprendi slideshow';
msg['LABEL_SCROLLBAR']='Posizione slider';
msg['LABEL_SLIDE']='Slide :index di :total';
msg['LABEL_ZOOMABLE_ITEM']='Clicca per ingrandire';
msg['LABEL_ZOOM_IN']='Ingrandisci';
msg['LABEL_ZOOM_OUT']='Riduci';
msg['MSG_ANNOUNCE_RELOAD']='Caricata pagina :title';
msg['MSG_CLOSE_TOOLTIP']='Chiudi';
msg['MSG_GENERIC_ERROR_WITH_CODE']="Spiacenti, si è verificato un errore. Contatta l'amministrazione riportando il codice di errore: ";
msg['MSG_PASSWORD_MODERATE']='Media';
msg['MSG_PASSWORD_NOT_EQUAL']='Le password non corrispondono.';
msg['MSG_PASSWORD_STRONG']='Forte';
msg['MSG_PASSWORD_VERY_STRONG']='Molto forte';
msg['MSG_PASSWORD_VERY_WEAK']='Molto debole';
msg['MSG_PASSWORD_WEAK']='Debole';
msg['MSG_PROGRESS_BAR_LABEL']="Mancano :delta paia per raggiungere il minimo d'ordine (:current/:goal)";
msg['MSG_PROGRESS_BAR_LABEL_MAX']="Minimo d'ordine raggiunto";
msg['MSG_QUANTITY_INPUT_ANNOUNCEMENT']='Quantità è ora :value';
msg['MSG_QUICKFILL_ADDED']='Aggiunta scatola da :value pezzi';
msg['MSG_QUICKFILL_REMOVED']='Rimossa scatola da :value pezzi';
msg['SIZE']='Taglia :size';

var portal_livestock_available='DISPONIBILE';
var portal_livestock_soldout='ESAURITO';

var activity_online_shop = 'negozio online';
var activity_shop = 'negozio';
var activity_private_sales = 'vendite private';
var activity_outlet = 'outlet';
var activity_online_outlet = 'outlet online';
var activity_store_chain = 'catena di negozi';
var activity_purchasing_group = 'gruppo di acquisto';
var activity_broker = 'broker/agent';
var activity_ebay_amazon = 'negozio ebay/amazon';
var activity_other = 'altro';

var general="General";
var general_personaldata='Dati personali';
var general_olduser='Utente registrato';
var general_newuser='Nuovo utente';
var general_username="Username";
var general_password="Password";
var general_contacts="Contatti";
var general_choosesize="Seleziona almeno una dimensione";
var general_phone="Telefono";
var general_skype="Skype";
var general_website="WebSite";
var general_fax="Fax";
var general_firstname='Nome';
var general_lastname='Cognome';
var general_company='Azienda';
var general_birth='Data di nascita';
var general_code='Codice';
var general_model='Modello';
var general_quantity='Quantit&agrave;';
var general_availability='Disponibilit&agrave;';
var general_price='Prezzo';
var general_warning='Attenzione';
var general_dispatchto='Destinatario';
var general_careof='C/O';
var general_vat='CF, P.IVA';
var general_address='Indirizzo';
var general_addresstype='Tipo via';
var general_addressnumber='Civico';
var general_city='Citt&agrave;';
var general_prov='Provincia';
var general_zip='CAP';
var general_mobile='Cellulare';
var general_notes='Note';
var general_orders='Ordini';
var general_fgfdiscounts='Amici e sconti';
var general_myprofile='Il mio profilo';
var general_pieces='pz';
var general_size_table='Tabella Taglie';
var general_details='Dettagli';
var general_invoice='Fattura';
var general_creditnote='Nota di credito';
var general_cart= 'Carrello';
var general_country='Nazione';
var general_carrier='Corriere';
var general_dispatch_address='Indirizzo di spedizione';
var general_invoice_address='Indirizzo di fatturazione';
var general_receive_newsletter='Ricevi Newsletter';
var general_copydispatchfrombilldata='Copia dai dati di fatturazione';
var general_instructions="Istruzioni";
var general_add="Aggiungi";
var general_status="Stato";
var general_toomanyfilters="Hai raggiunto il numero massimo di filtri permessi.";

var help_addresstype='Via, Piazza, Corso, ...';
var help_address='Inserire il nome della strada';
var help_dispatchmobile='Inserire un numero di telefono su cui poter essere contattati per la consegna.';
var help_ordercfpiva='Lasciando in bianco questo campo sar&agrave; applicata l\' IVA di default al valore dell\'ordine.';
var help_cf='Inserisci il tuo codice fiscale';

var buttons_save='Salva';
var buttons_changepw='Cambia password';
var buttons_close='Chiudi';
var buttons_continue='Continua';
var buttons_confirm='Conferma';
var buttons_cancel='Annulla';
var buttons_invite='Invita';
var buttons_continueshopping='Continua lo shopping';
var buttons_gocheckout='Vai al carrello';

var messages_product_soldout='Il prodotto &egrave; esaurito';
var messages_noselection='La selezione &egrave; vuota';
var messages_invaliddata='Compilare correttamente tutti i campi';
var messages_recoverpassword='Recupera password';
var messages_recoverpassword_info='Inserisci l\'indirizzo email con cui ti sei registrato. <br/>Ti sar&agrave; inviata un\'email con le istruzioni per impostare una nuova password.';
var messages_invitefriends='Invita gli amici';
var messages_confirmpassword='Conferma password';
var messages_sendingmail='Invio email in corso...';
var messages_mailsent='Email inviate con successo.';
var messages_password='Password';
var messages_confirmpassword='Conferma password';
var messages_requiredfield='Campo obbligatorio';

var subscribe_personaldata='Trattamento dei dati';
var subscribe_privacyintro='Per procedere con l\'iscrizione &egrave; necessario prendere visione della normativa sulla privacy e dare la propria autorizzazione al trattamento dei dati personali.';
var subscribe_privacydisclaimer='Devi accettare l\'informativa sulla privacy per completare la registrazione.'
var subscribe_privacy1='Il sottoscritto attesta di aver preso visione e accettato l\'informativa sulla privacy.';
var subscribe_privacy2='Il sottoscritto autorizza a comunicare i suoi dati a società terze per azioni commerciali (facoltativo)';

var order_status='Stato'
var order_date='Data'
var order_dispatchdate='Dispatched';

var returnedgoods_requests="Richieste di reso";
var returnedgoods_motivations="Motivo del reso";
var returnedgoods_requestcode="Codice reso";
var returnedgoods_requestdate="Richiesto il";
var returnedgoods_motivations_1="Il prodotto non è di mio gradimento";
var returnedgoods_motivations_2="Il prodotto è troppo grande/piccolo";
var returnedgoods_motivations_3="Il prodotto è danneggiato";
var returnedgoods_motivations_4="Il prodotto ricevuto non corrisponde al prodotto richiesto";
var returnedgoods_motivations_5="Il prodotto non è presente nella confezione";
var returnedgoods_motivations_other="Altro";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='Pendente';
i18nOrderStatus[1]='In pagamento';
i18nOrderStatus[2]='Confermato';
i18nOrderStatus[3]='Spedito';
i18nOrderStatus[4]='Consegnato';
i18nOrderStatus[5]='Prenotato';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='Annullato';
i18nOrderStatus[2001]='Errore';
i18nOrderStatus[3001]='In lavorazione';
i18nOrderStatus[3002]='Pronto';

i18nOrderStatus[1000]='Payment Cancelled';
i18nOrderStatus[2002]='Verifica pagamento fallita';
i18nOrderStatus[2003]='Rimborsato';
i18nOrderStatus[2005]='Rifiutato';
i18nOrderStatus[3003]='Non spedibile';
i18nOrderStatus[5001]='Non autorizzato';
i18nOrderStatus[5002]='Autorizzato';
i18nOrderStatus[5003]='Dropshipping - Growing';